import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { Form, RichTextInput, theme, Typography } from '@robinpowered/ui-kit';
import { useFormContext } from 'react-hook-form';
// Shared with the submit-time resolver so the inline error and the save
// blocker derive from the same constant.
import { MAX_DESCRIPTION_LENGTH } from '../../utils/composerIssues';
export var Description = function () {
    var _a;
    var t = useTranslation('meetingRooms').t;
    var _b = useFormContext(), setValue = _b.setValue, watch = _b.watch;
    var useToken = theme.useToken;
    var token = useToken().token;
    var description = watch('description');
    var isTooLong = ((_a = description === null || description === void 0 ? void 0 : description.length) !== null && _a !== void 0 ? _a : 0) > MAX_DESCRIPTION_LENGTH;
    var onUpdateDescription = function (value) {
        // Always store what the user typed — an early return here would leave the
        // form value stale, silently dropping the description from the payload.
        setValue('description', value, { shouldDirty: true });
    };
    return (_jsxs(Form.Item, { vertical: true, label: t("eventDetails.description.label"), style: { marginBottom: 0 }, children: [_jsx(RichTextInput, { styles: isTooLong
                    ? {
                        border: "1px solid ".concat(token.colorErrorBorder),
                    }
                    : {
                        listStyleType: 'disc',
                        border: "1px solid ".concat(token.colorBorder),
                    }, name: "description", "aria-label": t("eventDetails.description.label"), debounceUpdateTime: 100, onUpdate: function (value) { return onUpdateDescription(value); }, content: description || '', minContentHeight: '150' }), isTooLong && (_jsx(Typography.Text, { style: { color: token.colorErrorText }, children: t('create_event.errors.description_too_long', {
                    maxLength: MAX_DESCRIPTION_LENGTH,
                }) }))] }));
};
